import React from 'react';
import Portfolio from './Portfolio/Portfolio';



function App() {
  return (
    <Portfolio></Portfolio>
  );
}

export default App;
